module.exports = __webpack_public_path__ + "static/media/feature_monitoring.7115307a.png";